import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ICategoriaMateriaPrima } from '../model/categoria_materia_prima.model';

@Injectable()
export class CategoriaMateriaPrimaService extends EntityService<
  ICategoriaMateriaPrima
> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'categoria_materia_prima'
      }
    );
  }
}
